export default __webpack_public_path__ + "media/zurb/img/icons/favicon/mstile-150x150-1b7be7c6b648d2ba49bf5bfade417a60.png";